import * as z from 'zod'

export const VendorPixelTypeSchema = z.enum(['page-view', 'cta-click'])
export type VendorPixelType = z.infer<typeof VendorPixelTypeSchema>

/**
 * Schema for a single vendor pixel entry. The BE emits one entry per pixel,
 * carrying either a page-view or a click-event URL.
 *
 * During the BE/FE transition both shapes are accepted:
 * - Legacy fields (`clickEventUrl`, `pageViewUrl`) stay optional until BE drops them.
 * - New canonical fields (`type`, `url`, `targets`) are optional today and will
 *   eventually become required (and `type` discriminated) in a follow-up PR.
 *
 * `targets` (cta-click only) is a list of subset matchers against the click
 * payload parsed from `data-analytics-event`. OR across entries; AND on the
 * `(key, value)` pairs within each entry. Absent / empty array = fire on any
 * analytics-event click in the tracker tree.
 */
export const VendorPixelSchema = z.object({
  key: z.string(),

  // Legacy fields — optional throughout transition; removed once BE flips.
  clickEventUrl: z.string().optional(),
  pageViewUrl: z.string().optional(),

  // New canonical fields — optional during transition; eventually required.
  url: z.string().optional(),
  type: VendorPixelTypeSchema.optional(),
  targets: z.array(z.record(z.string(), z.string())).optional(),
})

export type VendorPixel = z.infer<typeof VendorPixelSchema>
